import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute } from '../route';

const searchSchema = z.object({
  policyId: z.string().uuid().optional(),
});

export const Route = createRoute({
  path: '/guardrail-policies',
  getParentRoute: () => pathlessAuthenticatedRoute,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const target = '/settings/organization/guardrail-policies' as const;
    throw redirect(
      search.policyId
        ? { to: target, search: { policyId: search.policyId } as never }
        : { to: target },
    );
  },
});
